export const ONBOARDING_WELCOME_MODAL_SHOWN = 'onboarding_welcome_modal_shown';
